<template>
<div id="content">
    <div class="container" id="about">
        <div class="row">
            <div class="col-md-3 sidebar visible-md-block visible-lg-block">
                <TheSidebar v-bind:routes="childRoutes"></TheSidebar>
            </div>

            <div class="col-md-9">
              <transition :name="transitionName">
                <router-view class="child-view"></router-view>
                </transition>
            </div>
        </div>
     </div>
</div>
</template>

<script>
import TheSidebar from "@/components/layout/TheSidebar";

export default {
  name: "GarageDoorSprings",
  components: { TheSidebar },
  data: function() {
    return {
      transitionName: 'slide-left',
      childRoutes: [
        { label: "Torsion Springs", routeName: "GarageDoorSpringsTorsion" },
        { label: "Extension Springs", routeName: "GarageDoorSpringsExtension" }
      ]
    };
  },
  beforeRouteUpdate (to, from, next) {
    const toDepth = to.path.split('/').length
    const fromDepth = from.path.split('/').length
    this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
    next()
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/GarageDoorSprings.vue